// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2x0b3","file":"styles_file__kLlBv"};